import React, { FC, ReactNode } from 'react';
import { MainLoader, ResourceGroup, ResourceLoader, useScopedSelector } from 'ia-react-core';
import NoResults from '../NoResults';
import ActionRequiredResource from '../../../../ActionRequiredResource';
import NotificationsResource from '../../../../NotificationsResource';
import OnlineTransactionResource from '../../../../OnlineTransactionResource';
import { NotificationsResourceInfo } from '../../../../NotificationsResource/NotificationsResource';
import { Notification } from '../../../../../interfaces/Notification';
import { ActionRequiredResourceInfo } from '../../../../ActionRequiredResource/ActionRequiredResource';
import { OnlineTransactionResourceInfo } from '../../../../OnlineTransactionResource/OnlineTransactionResource';

export interface NotificationsResourceGroupLoaderProps {
  children: ReactNode;
}

const NotificationsResourceGroupLoader: FC<NotificationsResourceGroupLoaderProps> = ({ children }) => {
  const promotions: Notification[] = useScopedSelector('/App.features.notifications.promotions', []);

  return (
    <>
      <ResourceGroup
        name="/App.features.notifications.notificationsResourceGroup"
        autoRequest
      >
        <OnlineTransactionResource />
        <ActionRequiredResource />
        <NotificationsResource />
      </ResourceGroup>
      <ResourceLoader
        resourceSrc="/App.features.notifications.notificationsResourceGroup"
        CustomNoDataMessage={NoResults}
        CustomLoader={MainLoader}
        requestOnLanguageChange
        getDataFromResponse={(data: { [key: string]: Notification[] }) => {
          const transactions = data[OnlineTransactionResourceInfo.name];
          const actions = data[ActionRequiredResourceInfo.name];
          const notifications = data[NotificationsResourceInfo.name];
          if (!transactions?.length && !actions?.length && !notifications?.length && !promotions?.length) return [];
          return [transactions, actions, notifications, promotions];
        }}
      >
        {children}
      </ResourceLoader>
    </>
  );
};

export default NotificationsResourceGroupLoader;
